<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-29 17:31:20
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-29 21:11:45
-->
<template>
  <span :class="['x-state-cell', stateClass]">
    <i class="icon-cell"></i>
    {{ text }}
  </span>
</template>
<script>
export default {
  name: 'XStateCell',
  props: {
    stateClass: {
      type: String,
      default: 'warning'
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.x-state-cell {
  &.success {
    color: #67c23a;

    i {
      background-color: #67c23a;
    }
  }

  &.blue {
    color: #017EFA;

    i {
      background-color: #017EFA;
    }
  }

  &.padding {
    color: #FF993C;

    i {
      background-color: #FF993C;
    }
  }

  &.warning {
    color: #e6a23c;

    i {
      background-color: #e6a23c;
    }
  }

  &.error {
    color: #F55248;

    i {
      background-color: #F55248;
    }
  }

  &.danger {
    color: #f56c6c;

    i {
      background-color: #f56c6c;
    }
  }

  &.gray {
    color: #909399;

    i {
      background-color: #909399;
    }
  }
}

i.icon-cell {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
</style>
